export default __webpack_public_path__ + "static/imgAboutUs-162117fd2ccad740c74c71c74a7a01ee.webp";